import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { CARDS, TRANSITION } from 'theme';

const propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.node.isRequired,
};

const defaultProps = {
    onClick: null,
};

const CardWrapperCSS = css`
    width: 100%;
    background-color: ${CARDS.BG};
    border: 0;
    border-radius: ${CARDS.BORDER_RADIUS};
    box-shadow: ${CARDS.BOX_SHADOW.BASE};
    text-align: left;
    transition: all ${TRANSITION.LENGTH} ${TRANSITION.BEZIER};
`;

const StyledCardWrapper = styled.div`
    ${CardWrapperCSS}
`;

const StyledCardWrapperButton = styled.button`
    ${CardWrapperCSS}
    min-height: 5em;
    padding: 0;
    cursor: pointer;

    &:hover,
    &:focus {
        box-shadow: ${CARDS.BOX_SHADOW.HOVER};
    }

    &:active {
        box-shadow: ${CARDS.BOX_SHADOW.ACTIVE};
    }
`;

const CardWrapper = ({ onClick, children, ...props }) => {
    return onClick ? (
        <StyledCardWrapperButton onClick={onClick} {...props}>
            {children}
        </StyledCardWrapperButton>
    ) : (
        <StyledCardWrapper {...props}>{children}</StyledCardWrapper>
    );
};

CardWrapper.propTypes = propTypes;
CardWrapper.defaultProps = defaultProps;

export default CardWrapper;
